import { Link } from 'react-router-dom';
import { membershipData } from '@/mocks/home';

const colorMap: Record<string, { card: string; badge: string; btn: string }> = {
  secondary: {
    card: 'border-secondary-200/70',
    badge: 'bg-secondary-500 text-background-50',
    btn: 'border-2 border-secondary-300 text-secondary-700 hover:bg-secondary-500 hover:text-background-50 hover:border-secondary-500',
  },
  primary: {
    card: 'border-primary-400 ring-2 ring-primary-200',
    badge: 'bg-primary-500 text-background-50',
    btn: 'bg-primary-500 text-background-50 hover:bg-primary-600',
  },
  accent: {
    card: 'border-accent-200/70',
    badge: 'bg-accent-500 text-background-50',
    btn: 'border-2 border-accent-300 text-accent-700 hover:bg-accent-500 hover:text-background-50 hover:border-accent-500',
  },
};

export default function MembershipSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">会员服务</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            选择适合您的会员方案，享受更多专属运动权益
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {membershipData.map((plan) => {
            const colors = colorMap[plan.color];
            return (
              <div
                key={plan.id}
                className={`relative bg-background-50 rounded-xl p-6 border ${colors.card} flex flex-col`}
              >
                {plan.popular && (
                  <div className={`absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-semibold ${colors.badge}`}>
                    最受欢迎
                  </div>
                )}
                <div className="text-center mb-5">
                  <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">{plan.name}</h3>
                  <div className="flex items-baseline justify-center gap-0.5">
                    <span className="text-foreground-500 text-sm">¥</span>
                    <span className="font-heading text-4xl font-bold text-foreground-900">{plan.price}</span>
                    <span className="text-foreground-500 text-sm">{plan.unit}</span>
                  </div>
                </div>

                <ul className="space-y-3 flex-1 mb-6">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-secondary-500 mt-0.5 flex-shrink-0"></i>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/category/membership"
                  className={`block text-center py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${colors.btn}`}
                >
                  立即开通
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}